export { customLocalStorage as default } from '@crehana/utils';
